export const EMPTY_NARRATIVES = [];
export const NARRATIVE_CREATED_LABEL = 'Created a new Narrative...';
